import React from 'react';
import { AppState } from '../../../../types/store';
import { connect } from 'react-redux';
import { getModuleData } from '../../../selectors/modules';
import {
  ExhibitionistSlideFitMode,
  ExhibitionistViewMode,
} from '../../../../types/modules';
import { GallectionType } from '../../../../types/gallection';

export interface WithModuleData {
  moduleData: {
    sourceType: GallectionType;
    viewMode: ExhibitionistViewMode;
    slideImageFit: ExhibitionistSlideFitMode;
  };
}

export const withModuleData = <T extends object>(
  Component: React.ComponentType<T>
) => {
  class ComponentWithModuleData extends React.Component<
    Partial<T & WithModuleData>
  > {
    render() {
      return <Component {...(this.props as T)} />;
    }
  }
  return connect((state: AppState, ownProps) => ({
    moduleData: getModuleData(state, ownProps.moduleId),
  }))(ComponentWithModuleData);
};

export default withModuleData;
